import '.d{display:flex;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.a{display:grid;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import { styled } from 'inlines'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import { useTranslations } from '@i18n/useLanguage'
import useMediaQuery from '@app/util/useMediaQuery'
import { useParamState } from '@app/util/hooks/useParamState'
import {
  regionalActueelTabs,
  regionalActueelTabsQueryParamName,
} from '@app/pages/discover/regions/constants'
import { pages } from '@app/util/links'
import { MunicipalityViewModel } from 'functions/app/geography/view/municipality'
import { match } from 'ts-pattern'
import type { ArticleContentItem } from '@app/components/blocks/ArticleSection'

type ActueelTab = keyof typeof regionalActueelTabs

const getItemsForTab = (
  municipality: MunicipalityViewModel,
  tab: ActueelTab,
): ArticleContentItem[] => {
  return match(tab)
    .with(regionalActueelTabs.verhalen, () => municipality.stories ?? [])
    .with(regionalActueelTabs.news, () => municipality.news ?? [])
    .with(regionalActueelTabs.blog, () => municipality.blogs ?? [])
    .exhaustive()
}

export const MunicipalityActueelTab = ({
  municipality,
  municipalitySlug,
}: {
  municipality: MunicipalityViewModel
  municipalitySlug: string
}) => {
  const isMobile = useMediaQuery()
  const t = useTranslations()
  const [actueelTab, setActueelTab] = useParamState(
    regionalActueelTabs,
    regionalActueelTabsQueryParamName,
    regionalActueelTabs.verhalen,
  )

  const items = getItemsForTab(municipality, actueelTab)

  return (
    <Column alignItems="stretch" gap={isMobile ? '1rem' : '2rem'}>
      <Title.H1 style={{ textAlign: 'center' }}>
        {t.app.blogPage.title}
      </Title.H1>

      <div className="d ax"
      >
        <TabsGroup
          selectedTab={actueelTab}
          onSelectTab={setActueelTab}
          tabs={[
            {
              value: regionalActueelTabs.verhalen,
              label: t.app.blogPage.tabs.stories,
            },
            {
              value: regionalActueelTabs.news,
              label: t.app.blogPage.tabs.news,
            },
            {
              value: regionalActueelTabs.blog,
              label: t.app.blogPage.tabs.blog,
            },
          ]}
        />
      </div>

      {items.length === 0 ? (
        <styled.div>{t.app.blogPage.noContent}</styled.div>
      ) : (
        <div className="a c"
          style={{
            gridTemplateColumns: isMobile
              ? 'minmax(0, 1fr)'
              : 'repeat(3, minmax(0, 1fr))',}}
        >
          {items.map((item, index) => (
            <BlogCard
              key={item.id}
              style={
                index === 0 && !isMobile ? { gridColumn: 'span 2' } : undefined
              }
              orientation={index === 0 && !isMobile ? 'horizontal' : 'vertical'}
              image={item.images?.[0]}
              meta={
                item.publishedAt
                  ? new Date(item.publishedAt).toLocaleDateString()
                  : undefined
              }
              title={item.title}
              to={pages.municipalityArticle(
                municipalitySlug,
                actueelTab,
                item.slug,
              )}
              imageStyle={
                index === 0 && !isMobile
                  ? {
                      aspectRatio: '1/1',
                      width: 'auto',
                      maxHeight: '25rem',
                    }
                  : undefined
              }
              intro={index === 0 && !isMobile ? item.intro : undefined}
            />
          ))}
        </div>
      )}
    </Column>
  )
}
